module.exports = __webpack_public_path__ + "img/semi_stopped.3553468b.svg";